import Http from './http';

export const disableSupermarket = ({
    subscriptionCode
}) => Http.post('disable_user', {
    subscriptionCode
});


export const createAdmin = (admin) => Http.post('createAdmin', admin);

export const createNewSupermarket = (newUserData) => Http.post('new_supermarket', newUserData);

export const deleteMasterByEmail = (email) => Http.post('deleteAdmin', {email});
